import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const CONSENT_KEY = "nm_analytics_consent";
const GOLD = "#c9a96e";

export function getAnalyticsConsent() {
  return localStorage.getItem(CONSENT_KEY);
}

export default function CookieBanner({ onAccept, onReject }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) setShow(true);
  }, []);

  if (!show) return null;

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setShow(false);
    onAccept?.();
  };

  const reject = () => {
    localStorage.setItem(CONSENT_KEY, "rejected");
    setShow(false);
    onReject?.();
  };

  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: "#111",
      borderTop: `2px solid ${GOLD}`,
      padding: "1rem 1.5rem",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "0.75rem",
      justifyContent: "space-between",
      boxShadow: "0 -4px 24px rgba(0,0,0,0.5)",
    }}>
      <div style={{ flex: 1, minWidth: 220, color: "#ccc", fontSize: "0.83rem", lineHeight: 1.65 }}>
        <span style={{ color: GOLD, fontWeight: 700 }}>Cookie & Privacy</span>
        {": "}
        {t(
          "cookie.testo",
          "Usiamo Google Analytics 4 per analizzare il traffico in forma anonimizzata. Puoi accettare o rifiutare senza conseguenze."
        )}{" "}
        <a href="/privacy-policy" style={{ color: GOLD, textDecoration: "underline" }}>Privacy Policy</a>
      </div>
      <div style={{ display: "flex", gap: "0.5rem", flexShrink: 0 }}>
        <button
          onClick={reject}
          style={{
            background: "transparent", color: "#999", border: "1px solid #555",
            borderRadius: 20, padding: "7px 18px", fontSize: "0.8rem", cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          {t("cookie.rifiuta", "Rifiuta")}
        </button>
        <button
          onClick={accept}
          style={{
            background: GOLD, color: "#1a1a1a", border: "none",
            borderRadius: 20, padding: "7px 18px", fontSize: "0.8rem",
            fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
          }}
        >
          {t("cookie.accetta", "Accetta")}
        </button>
      </div>
    </div>
  );
}
